const getOpeFoxSdk = ({
  profileId,
  anonymousId,
  lastAnonymousProfileId,
  isSignedIntoProfile,
  lastKnownProfileID,
}) => `(function(o,n,e,p,l,u,s){o[l]=o[l]||function(){(o[l].q=o[l].q||[]).push(arguments);};
    u=n.createElement(e);u.async=1;u.src=p;s=n.getElementsByTagName(e)[0];s.parentNode.insertBefore(u,s);
    }(window,document,"script","https://cdn.opecloud.com/ope-fox.js","ope"));

    ope("fox", "init", "usp")
    ope("fox", "send", "profile_ids", {
        dcg_profile_id: "${profileId}",
        segment_anonymous_d: "${anonymousId}",
        lastAnonymousProfileID: "${lastAnonymousProfileId}", 
        lastKnownProfileID: "${lastKnownProfileID}",
        isSignedIntoProfile: ${isSignedIntoProfile}
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (window.location.href.includes("?")) 
    {
    ope("fox", "send", "utmParameters", {
    utm_source: urlParams.get("utm_source"),
    utm_medium: urlParams.get("utm_medium"),
    utm_term: urlParams.get("utm_term"),
    utm_campaign: urlParams.get("utm_campaign")
    });
    }
    `;

export default getOpeFoxSdk;
